import styled from 'styled-components';
import { Grid, Typography, Link } from "@mui/material";

export const StyledTopNav = styled.div(({theme}) => `
    background-color: ${theme.uptimeColors.mainTheme.primary};
    height: 54px;
    min-height: 54px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    font-size: ${theme.uptimeFontSizes.desktop.fz5}px !important;
    font-weight: 500 !important;
   
    @media (min-width: 320px) {
        padding: ${theme.uptimeSpace[0]} 50px;
    };

    @media (min-width: 1024px) {
        padding:  ${theme.uptimeSpace[0]} 152px;
    };
`);

export const StyledHeader = styled.div(({theme}) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .header-left {
        display: flex;
        align-items: center;
    };

    .header-right {
        display: flex;
        align-items: center;
        &.img {
            background-color:  ${theme.uptimeColors.grayScales.white} !important;
            border-radius: 50%;
            width: 24px;
            height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    };
`);

export const StyledLogo = styled.img(({theme}) => `
    &.logo {
        height: 36px;
        width: 100%;
    };

    &.icon {
        background-color:  ${theme.uptimeColors.grayScales.white} !important;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px;
    };

    &.main-image {
        width: 90%;
        margin: 35px auto;
    };

    &.brand {
        width: 300px;
        padding: ${theme.uptimeSpace[10]}px ${theme.uptimeSpace[0]};
    };

    @media (min-width: 320px) {
        &.main-image {
            margin: ${theme.uptimeSpace[0]};
        };
    };
    
    @media (min-width: 1024px) {
        &.main-image {
            margin: 35px auto;
        };
    };
`);


export const StyledContainer = styled.div(({theme}) => `
    display: flex;
    min-height: 700px;
    width: 100%;
    padding: ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[0]} ${theme.uptimeSpace[10]}px;
    margin: ${theme.uptimeSpace[0]} !important;
    background-color: #fafafa;
    
`);

export const StyledGrid = styled(Grid)(({theme}) => `
    margin: 50px; 
   &.content-left {
    padding: ${theme.uptimeSpace[0]};
   };

   &.content-right {
    padding: ${theme.uptimeSpace[0]};
   };

   @media (min-width: 320px) {
        &.content-left {
            flex-basis: 100%;
            max-width: 100%;
        };
    
       &.content-right {
            flex-basis: 100%;
            max-width: 100%;
       };
    };

    @media (min-width: 1024px) {
        &.content-left {
            max-width: 50%;
        };
    
       &.content-right {
            max-width: 50%;
       };
    }
`);

export const StyledTypography = styled(Typography)(({theme}) => `
    padding: ${theme.uptimeSpace[5]}px ${theme.uptimeSpace[0]};
    &.main {
        font-weight: bolder; 
    };

    &.list {
        padding-left: ${theme.uptimeSpace[10]}px;
    };

    @media (min-width: 320px) {
        &.main {
            font-size: ${theme.uptimeFontSizes.desktop.fz9}px;
        };
    };

    @media (min-width: 1024px) {
        &.main {
            font-size: ${theme.uptimeFontSizes.desktop.fz11}px;
        };    
    };
`);

export const StyledLink = styled(Link)(({theme}) => `
    &.link {
        color: ${theme.uptimeColors.mainTheme.primary};
        font-weight: bold;
        text-decoration: none !important;  
    };
`);
